import { Grid } from '@mui/material';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { useEventCallback } from '@mui/material';
import { DatePicker } from '@mui/lab';
import ListCommunication, { ID_COMMUNICATION } from '../list/list-communication';
import { SelectChangeEvent } from '@mui/material';
import ListAnsc from '../../../../../../shared/list-ansc';
import { ItemVM } from 'shell/view-models/item';

interface ConsciousDataProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
}

const ConsciousDataComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  onChanges,
}: ConsciousDataProps): React.ReactElement => {
  const handleListCommunication = useEventCallback((event: SelectChangeEvent<string>) => {
    onChanges({
      typeCommunication: { id: event.target.value, value: '' },
      otherTypeCommunicationDescription: '',
    });
  });

  const handleListAddress = useEventCallback((item?: ItemVM) => {
    onChange('address', item?.id);
  });

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data invio *"
          aria-label="Data invio"
          value={values?.dataSend || null}
          onChange={(date) => {
            onChange('dataSend', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dataSend"
              fullWidth
              helperText={errors?.dataSend}
              error={touched?.dataSend && Boolean(errors?.dataSend)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListCommunication
          value={values?.typeCommunication?.id?.toString() || ''}
          onChange={handleListCommunication}
          disabled={disabled}
          error={Boolean(errors?.typeCommunication) && touched?.typeCommunication}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        {values?.typeCommunication?.id?.toString() === ID_COMMUNICATION.ID_ALTRO_MEZZO ? (
          <PmiTextField
            label="Descrizione altro mezzo di comunicazione *"
            aria-label="Descrizione altro mezzo di comunicazione"
            id="otherTypeCommunicationDescription"
            name="otherTypeCommunicationDescription"
            fullWidth
            disabled={disabled}
            helperText={errors?.otherTypeCommunicationDescription}
            error={
              touched?.otherTypeCommunicationDescription &&
              Boolean(errors?.otherTypeCommunicationDescription)
            }
            type="text"
            variant="outlined"
            value={values?.otherTypeCommunicationDescription || ''}
            onChange={(event) => {
              onChange('otherTypeCommunicationDescription', event.target.value);
            }}
          />
        ) : undefined}
      </Grid>
      <Grid item xs={12} md={4}>
        <ListAnsc
          label="Indirizzo di invio"
          idDominio="56"
          value={values?.address || ''}
          onChange={handleListAddress}
          disabled={disabled}
          error={Boolean(errors?.address) && touched?.address}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data ricezione *"
          aria-label="Data ricezione"
          value={values?.dataReception || null}
          onChange={(date) => {
            onChange('dataReception', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dataReception"
              fullWidth
              helperText={errors?.dataReception}
              error={touched?.dataReception && Boolean(errors?.dataReception)}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

ConsciousDataComponent.displayName = 'Form Conscious Data component';

const ConsciousData = memo(ConsciousDataComponent);

export default ConsciousData;
